import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconTypes, PencilIconComponent } from '../pencil-icon/pencil-icon.component';

@Component({
  selector: 'app-pncl-menu-header',
  templateUrl: './pncl-menu-header.component.html',
  styleUrls: ['./pncl-menu-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, PencilIconComponent],
})
export class PnclMenuHeaderComponent {
  @Input() title: string = '';
  @Input() preFixIcon?: string;
  @Input() preFixIconType = IconTypes.svgIcon;
}
